import { useCallback } from "react";
import { useCalendlyAdapterAxiosInstance } from "./useCalendlyAdapterAxiosInstance.ts";
import dayjs from "dayjs";
import { useWithLoading } from "../UI/Loading/useWithLoading.ts";
export type AvailableUserDTO = {
  email: string;
  uri: string;
};

export function useExportCalendlyAvailability() {
  const axiosInstance = useCalendlyAdapterAxiosInstance();
  const { withLoading, loading } = useWithLoading<void>();
  const exportAvailabilityCall = useCallback(
    async ({
      fromIncl,
      toIncl,
      filteredUsers,
    }: {
      fromIncl: Date;
      toIncl: Date;
      filteredUsers?: string[];
    }) => {
      const formattedFromIncl = dayjs(fromIncl).format();
      const formattedToIncl = dayjs(toIncl).format();
      let formattedFilteredUsers = "";
      if (filteredUsers && filteredUsers.length > 0)
        formattedFilteredUsers = `&filteredEmails=${filteredUsers.join(",")}`;

      const response = await axiosInstance.get(
        `/organization-availability/export-csv?fromIncl=${encodeURIComponent(formattedFromIncl)}&toIncl=${encodeURIComponent(formattedToIncl)}${formattedFilteredUsers}`,
        {
          responseType: "blob",
        },
      );

      const contentDisposition = response.headers["content-disposition"];
      const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
      const filename = filenameMatch
        ? filenameMatch[1]
        : `availability_${dayjs(fromIncl).format("YYYY-MM-DD")}_to_${dayjs(toIncl).format("YYYY-MM-DD")}.csv`;

      const blob = new Blob([response.data], {
        type: "text/csv; charset=utf-8",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    [axiosInstance],
  );

  const exportCalendlyAvailability = useCallback(
    async ({
      fromIncl,
      toIncl,
      filteredUsers,
    }: {
      fromIncl: Date;
      toIncl: Date;
      filteredUsers?: string[];
    }) => {
      return await withLoading(() =>
        exportAvailabilityCall({ fromIncl, toIncl, filteredUsers }),
      );
    },
    [withLoading, exportAvailabilityCall],
  );

  return {
    exportCalendlyAvailability,
    loading,
  };
}
